// Intercepteur global de fetch (AUTH_PLAN.md §5.1), installé dans index.js avant le rendu.
// Pour tout appel à l'API Walter (URL qui commence par REACT_APP_API_URL) :
// - ajoute `credentials: 'include'`, pour que le cookie de session parte avec la requête ;
// - sur un 401 hors de /auth/*, émet `walter:unauthorized` : AuthContext ouvre alors la
//   modale de reconnexion par-dessus la page, sans perdre ce qui est en cours de saisie.
// Couvre ainsi les appels existants, la file hors-ligne (syncEngine) et les appels à venir,
// sans toucher aux appels externes (api-adresse, Géorisques, Open-Meteo…).

const API_URL = process.env.REACT_APP_API_URL;

export const UNAUTHORIZED_EVENT = 'walter:unauthorized';
export const AUTHENTICATED_EVENT = 'walter:authenticated';

function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    return input?.url || '';
}

export function installAuthFetch() {
    if (!API_URL || window.fetch.walterAuth) return;
    const originalFetch = window.fetch.bind(window);

    const authFetch = async (input, init = {}) => {
        const url = requestUrl(input);
        if (!url.startsWith(API_URL)) return originalFetch(input, init);
        const response = await originalFetch(input, { ...init, credentials: 'include' });
        if (response.status === 401 && !url.startsWith(`${API_URL}/auth/`)) {
            window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
        }
        return response;
    };
    authFetch.walterAuth = true;
    window.fetch = authFetch;
}
